import React from 'react';

interface Badge {
  badge: string;
  earned: boolean;
}

interface ProfileBadgesProps {
  badges: Badge[];
}

const ProfileBadges: React.FC<ProfileBadgesProps> = ({ badges }) => {
  const labels = {
    new_candidate: "New Profile",
    complete_profile: "Complete Profile",
    active_user: "Active",
    temp_veteran: "Temp Veteran",
    new_temp: "New Temp",
    high_rating: "Top Rated",
    popular_temp: "Popular",
    top_rated_temp: "Top Rated Temp"
  };

  const icons = {
    new_candidate: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/New Canditate.png",
    complete_profile: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/Profile Completed.png",
    active_user: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/Active User.png",
    temp_veteran: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/Veteran Temp.png",
    new_temp: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/New Temp.png",
    high_rating: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/Top Rated Temp.png",
    popular_temp: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/Popular Temp.png",
    top_rated_temp: "https://directdentalstaffing.sfo3.cdn.digitaloceanspaces.com/profile-badges/Top Rated Temp.png"
  };

  const earnedBadges = badges.filter(badge => badge.earned);

  if (earnedBadges.length === 0) {
    return null;
  }

  return (
    <div className="d-flex gap-1 flex-wrap">
      {earnedBadges.map((badge, index) => (
        <div key={index} className="profile-badge">
          <img
            src={icons[badge.badge]}
            alt={badge.badge}
            className="profile-badge__icon"
          />
          <span className="profile-badge__text">{labels[badge.badge]}</span>
        </div>
      ))}
    </div>
  );
};

export default ProfileBadges;
